import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Check, CheckBox, ColorLens, ExpandMore, FormatPaint, FormatSize, TextFormat } from '@mui/icons-material';
import { Box, Button, IconButton, ListItemIcon, Menu, MenuItem, Stack, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import * as lstCor from '@mui/material/colors';

const IB = styled(IconButton)(({ theme }) => ({
  borderRadius: 0,
}));
const FONT_SAFE = [
  "Default", "Arial", "Verdana", "Tahoma", "Trebuchet MS", "Times New Roman", "Georgia", "Garamond", "Courier New", "Brush Script MT"
]
const COLOR_LIST = [
  "amber", "blue", "blueGrey", "brown",
  // "common", 
  "cyan", "deepOrange", "deepPurple", "green", "grey", "indigo", "lightBlue", "lightGreen", "lime", "orange", "pink", "purple", "red", "teal", "yellow"
];
const COLOR_TOM = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];
export default function FontPopover(props) {
  const { setElemento, format } = props;
  const [corType, setCorType] = React.useState();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElSize, setAnchorElSize] = React.useState(null);
  const [anchorElFont, setAnchorElFont] = React.useState(null);
  const [anchorElFontColor, setAnchorElFontColor] = React.useState(null);

  const [fontSelected, setFontSelected] = React.useState('Default');
  const [fontFamilySelected, setFontFamilySelected] = React.useState('Default');

  const openSize = Boolean(anchorElSize);
  const openFont = Boolean(anchorElFont);
  const openFontColor = Boolean(anchorElFontColor);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  React.useEffect(() => {
    if (openSize || openFont) {
      const el = getParentElement();
      // setRootEl(el);
      if (el) {
        const style = buscaStyleRecursivo(el);
        console.log(style);
        if (style) {
          let f = style.fontSize;
          if (f && f.length > 0) {
            console.log(f.replace("px", ""))
            setFontSelected(f.replace("px", ""));
          } else {
            setFontSelected('Default');
          }

          let font = style.fontFamily;
          if (font && font.length > 0) {
            let arr = font.split(',');
            let txt = arr[0].replace("\"", '');
            txt = txt.replace("\"", '')
            console.log(txt)
            setFontFamilySelected(txt);
          } else {
            setFontFamilySelected('Default');
          }
        }
      }
    }
  }, [openSize, openFont]);

  function buscaStyleRecursivo(el) {
    console.log(el)
    if (!el) return null;
    if (el.getAttribute('contenteditable')) {
      console.log('>>>nao pode<<<<')
      return null;
    }
    let style = el.style;
    if (style) return style;
    else return buscaStyleRecursivo(el.parentElement);
  }
  const handleClick = (event) => {
    // setSelection(cloneSelectionRanges())
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // setSelection();
  };
  const handleCloseFont = () => {
    setAnchorElFont(null);
  };
  const handleCloseSize = () => {
    setAnchorElSize(null);
  };
  const handleCloseFontColor = () => {
    setAnchorElFontColor(null);
  }

  function handleSetFont(font) {
    const elP = getParentElement();
    console.log(elP);
    if (elP.tagName === 'SPAN') {
      if (font === 'Default') {
        elP.style.fontFamily = null;
      } else {
        elP.style.fontFamily = font + ', sans-serif';
      }
    } else {
      const el = document.createElement('span');
      el.style.fontFamily = font + ', sans-serif';
      // el.style.fontWeight = 'bold';
      // el.style.color = 'blue';
      setElemento(el);
    }
    handleCloseFont();
    handleClose();
  }
  function handleSetSize(size) {
    const elP = getParentElement();
    console.log(elP);

    if (elP.tagName === 'SPAN') {
      if (size === 'Default') {
        elP.style.fontSize = null;
      } else {
        elP.style.fontSize = size + 'px';
      }
    } else {
      const el = document.createElement('span');
      // Set the text content of the paragraph
      // el.textContent = 'This is dynamically created text with custom font styles.';

      // Apply font styles using the style property
      // el.style.fontFamily = 'Arial, sans-serif';
      el.style.fontSize = size + 'px';
      // el.style.fontWeight = 'bold';
      // el.style.color = 'blue';
      setElemento(el);
    }
    handleCloseSize();
    handleClose();
  }

  function getParentElement() {
    const s = window.getSelection();
    if (s && s.rangeCount === 1) {
      const base = s.getRangeAt(0);//s.baseNode;
      const el = base.startContainer.parentElement;
      return el;
    }
    return null;
  }

  function handleColorChose(cor) {
    console.log(cor);

    handleCloseFontColor();
    handleClose();

    const elP = getParentElement();
    
    if (elP.tagName === 'SPAN') {
      if (cor === 'Default') {
        if (corType === 'front') {
          elP.style.color = null;
        } else {
          elP.style.background = null;
        }
      } else {
        const selecao = window.getSelection();
        const txt = selecao.toString().trim();
        const temTextoSelecionado = txt.length > 0;        
        if (temTextoSelecionado) {
          const el = document.createElement('span');
          if (corType === 'front') {
            el.style.color = cor;
          } else {
            el.style.background = cor;
          }
          setElemento(el);
        } else if (corType === 'front') {
          elP.style.color = cor;
        } else {
          elP.style.background = cor;
        }
      }
    } else {
      console.log(3)
      const el = document.createElement('span');
      if (corType === 'front') {
        el.style.color = cor;
      } else {
        el.style.background = cor;
      }
      setElemento(el);
    }
    handleCloseFontColor();
    handleClose();
  }

  function cloneSelectionRanges() {
    const selection = window.getSelection();
    const clonedRanges = [];

    // Iterate through all ranges in the selection (there can be multiple)
    for (let i = 0; i < selection.rangeCount; i++) {
      const range = selection.getRangeAt(i);
      clonedRanges.push(range.cloneRange()); // Use cloneRange() to create a new, independent Range object
    }
    return clonedRanges;
  }
  function handleAbrerCorFront(e) {
    setAnchorElFontColor(e.currentTarget);
    setCorType("front");
  }
  function handleAbrerCorBack(e) {
    setAnchorElFontColor(e.currentTarget);
    setCorType("back");
  }

  return (
    <React.Fragment>
      <Tooltip title="Formata Texto">
        <IB
          color={format ? 'primary' : 'secundary'}
          onClick={handleClick}
          size="small"
        >
          <TextFormat />
        </IB>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Stack direction="row">
          <Tooltip title="Formata Texto">
            <IB

              onClick={e => setAnchorElSize(e.currentTarget)}
            // size="small"
            >
              <FormatSize />
            </IB>
          </Tooltip>
          <Tooltip title="Font-family">
            <Button onClick={e => setAnchorElFont(e.currentTarget)}
              variant="text" color='secundary'
              endIcon={<ExpandMore />}
            >
              Font-family
            </Button>
          </Tooltip>
          <Tooltip title="Cor da Fonte">
            <IB
              // color="primary"
              onClick={handleAbrerCorFront}
            // size="small"
            >
              <ColorLens />
            </IB>
          </Tooltip>
          <Tooltip title="Cor de fundo">
            <IB
              // color="primary"
              onClick={handleAbrerCorBack}
            // size="small"
            >
              <FormatPaint />
            </IB>
          </Tooltip>

        </Stack>
      </Popover>
      <Menu
        id="basic-menu"
        anchorEl={anchorElSize}
        open={openSize}
        onClose={handleCloseSize}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {[10, 12, 'Default', 14, 16, 18, 20, 22, 24].map((i) =>
          <MenuItem
            key={i} onClick={() => handleSetSize(i)}
            selected={fontSelected == i}
          >
            {fontSelected == i &&
              <ListItemIcon>
                <Check />
              </ListItemIcon>}
            {i}
          </MenuItem>
        )}
      </Menu>
      <Menu
        id="menu-font-family"
        anchorEl={anchorElFont}
        open={openFont}
        onClose={handleCloseFont}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {FONT_SAFE.map((i) =>
          <MenuItem
            key={i} onClick={() => handleSetFont(i)}
            selected={fontFamilySelected == i}
          >
            {fontFamilySelected == i &&
              <ListItemIcon>
                <Check />
              </ListItemIcon>}
            {i}
          </MenuItem>
        )}
      </Menu>
      <Menu
        id="menu-font-color"
        anchorEl={anchorElFontColor}
        open={openFontColor}
        onClose={handleCloseFontColor}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        <Stack direction="row" spacing={0}>
          <Box sx={{
            p: 1, border: '1px solid grey', fontSize: '12px',
          }}
          >
            Default
          </Box>
          {COLOR_LIST.map((c, i) =>
            <Stack key={i + "-cor"}>
              <Box sx={{
                p: 1, border: '1px solid grey', fontSize: '12px',
                background: lstCor[c][500]
              }}
              >
                {c}
              </Box>
              {COLOR_TOM.map((t, index) =>
                <Box key={i + "-tom-" + index} sx={{
                  p: 1, border: '1px solid grey', fontSize: '12px',
                  background: lstCor[c][t],
                  // cursor: 'pointer'
                }}
                  component="button"
                  onClick={() => handleColorChose(lstCor[c][t])}
                />
              )}
            </Stack>
          )}
        </Stack>
      </Menu>
    </React.Fragment>
  );
}
